import { transSericeApolloClient } from '@/graphql/client'
import { GET_CLINIC } from '@/graphql/queries/my-calendar'

// Initial state with sample data and additional fake data
const state = {
  backendusers: {},
  backendusersLastPage: 0, // Track the last page loaded from API

  patients: {
    '3123765': {
      "Basic_Info": {
        "Contact_Info": {
          "phone": "(415) 555-3921",
          "email": "john.martinez83@examail.com",
          "address": "245 Pine St, San Francisco, CA 94104",
          "preferredContact": "Phone"
        },
        "Emergency_Contact": {
          "name": "Maria Martinez",
          "relationship": "Spouse",
          "phone": "(415) 555-3922",
          "email": "maria.martinez@examail.com"
        },
        "Date_of_Birth": "1983-02-14",
        "Demographics": {
          "gender": "Male",
          "age": 41,
          "dateOfBirth": "1983-02-14",
          "formattedDateOfBirth": "Feb-14-1983",
          "race": "Hispanic",
          "ethnicity": "Hispanic"
        },
        "Billing_Preference": {
          "method": "Provider bill",
          "address": "245 Pine St, San Francisco, CA 94104"
        },
        "Order_Handling_Preference": {
          "bloodKit": "Ship to patient",
          "nonBloodKit": "Office supply",
          "shippingAddress": "245 Pine St, San Francisco, CA 94104"
        }
      },
      "Medical_Record": {
        "Medication": [
          {
            "id": "med_001",
            "name": "Atorvastatin",
            "brandName": "Lipitor",
            "dosage": "20mg",
            "frequency": "Daily",
            "instructions": "1 tablet daily",
            "startDate": "2022-06-12",
            "formattedStartDate": "Jun-12-2022",
            "prescribedBy": "Dr. Smith",
            "status": "Active"
          }
        ],
        "Allergies": ["Penicillin"],
        "Encounter_Notes": [
          {
            "id": "enc_001",
            "type": "Office Visit",
            "date": "2025-03-18",
            "formattedDate": "Mar-18-2025",
            "provider": "Dr. Johnson",
            "notes": "Regular checkup and medication review"
          }
        ],
        "All_Documents": {
          "totalDocs": 4,
          "medicalReports": 2,
          "encounterNotes": 1,
          "uploadedDocs": 1
        }
      },
      "Calendar": {
        "Appointments": [
          {
            "event_id": 1001,
            "uuid": "appt-uuid-001",
            "event_title": "Cardiology Follow-up",
            "notes": "Follow-up appointment for cardiology consultation",
            "practice_id": 150105,
            "creator_calendar_id": 30790,
            "event_type": "appointment",
            "color_id": null,
            "external_url": null,
            "google_event_id": null,
            "outlook_event_id": null,
            "zoom_event_id": null,
            "is_canceled": false,
            "start_time": "2025-09-24T10:00:00.000Z",
            "end_time": "2025-09-24T11:00:00.000Z",
            "location": "Cardiology Clinic - Room 302",
            "timezone": "America/Los_Angeles",
            "rrule": null,
            "recurrence_id": null,
            "patient_ids": [3123765],
            "accession_ids": null,
            "create_time": "2025-08-01T10:00:00.000Z",
            "update_time": "2025-08-01T10:00:00.000Z",
            "participants": [
              {
                "id": 5001,
                "event_id": 1001,
                "participant_calendar_id": 30790,
                "role": "organizer",
                "status": "accepted",
                "created_at": "2025-08-01T10:00:00.000Z",
                "updated_at": "2025-08-01T10:00:00.000Z"
              }
            ]
          },
          {
            "event_id": 1002,
            "uuid": "appt-uuid-002",
            "event_title": "Lab Results Review",
            "notes": "Review recent lab test results",
            "practice_id": 150105,
            "creator_calendar_id": 30790,
            "event_type": "appointment",
            "color_id": null,
            "external_url": "https://zoom.us/j/83910239483",
            "google_event_id": null,
            "outlook_event_id": null,
            "zoom_event_id": "83910239483",
            "is_canceled": false,
            "start_time": "2025-09-30T14:00:00.000Z",
            "end_time": "2025-09-30T14:30:00.000Z",
            "location": "Zoom Meeting",
            "timezone": "America/Los_Angeles",
            "rrule": null,
            "recurrence_id": null,
            "patient_ids": [3123765],
            "accession_ids": null,
            "create_time": "2025-08-15T10:00:00.000Z",
            "update_time": "2025-08-15T10:00:00.000Z",
            "participants": [
              {
                "id": 5002,
                "event_id": 1002,
                "participant_calendar_id": 30790,
                "role": "organizer",
                "status": "accepted",
                "created_at": "2025-08-15T10:00:00.000Z",
                "updated_at": "2025-08-15T10:00:00.000Z"
              }
            ]
          }
        ],
        "Tasks": [
          {
            "id": "task_001",
            "title": "Log daily blood pressure",
            "description": "Record blood pressure readings twice daily",
            "priority": "High",
            "status": "Pending",
            "dueDate": "2025-08-15",
            "formattedDueDate": "Aug-15-2025",
            "assignedBy": "Dr. Johnson",
            "category": "Health Monitoring",
            "estimatedDuration": "5 minutes"
          }
        ],
        "Form": [
          {
            "id": "form_001",
            "title": "First Visit Intake Form",
            "description": "Complete intake form for new patient visit",
            "status": "Pending",
            "dueDate": "2025-08-10",
            "formattedDueDate": "Aug-10-2025",
            "formType": "Intake Form",
            "estimatedTime": "15 minutes",
            "assignedBy": "Front Desk",
            "priority": "High"
          }
        ],
        "Assigned_Questionnaire": [
          {
            "id": "quest_001",
            "title": "Depression Screening (PHQ-9)",
            "description": "Mental health screening questionnaire",
            "status": "Unfinished",
            "dueDate": "2025-08-20",
            "formattedDueDate": "Aug-20-2025",
            "questionnaireType": "Mental Health",
            "estimatedTime": "10 minutes",
            "assignedBy": "Dr. Johnson",
            "priority": "Medium",
            "totalQuestions": 9
          }
        ]
      },
      "Billing": {
        "Billing": [],
        "Sample": [
          {
            id: 'sample_001',
            serviceDate: 'Sep-18-2025',
            status: 'Order Created',
            statusDescription: 'The order has been successfully created in the system.',
            sampleId: '1',
            orderTestNames: 'Autoimmune Zoomer',
            samplePlacedDate: '2025-08-02',
            questionnaireStatus: '–',
            questionnaireDescription: '–'
          }
        ],
        "Orders": [],
        "VitalSigns": {
          "height": "5'9\"",
          "weight": "180 lb"
        }
      }
    }
  },

  pegboardCardVersion: null,
  patientCalendarIdMap: {}, // Store patient ID → calendar ID mapping
  // Shared medication and allergy data for current patient (synced between left panel and pegboard)
  currentPatientMedications: [],
  currentPatientAllergies: [],
  currentPatientHealthInfo: null,
  currentPatientBillingOrders: [], // Current patient's billing orders
  currentPatientDocuments: [], // Current patient's documents/files
  currentPatientAppointments: [], // Current patient's fetched appointments from calendar
  currentPatientTasks: [], // Current patient's fetched tasks from calendar
  medicationsLoading: false,
  allergiesLoading: false,
  healthInfoLoading: false,
  billingOrdersLoading: false,
  documentsLoading: false,
  pegboardLoading: false,
  appointmentsLoading: false,
  tasksLoading: false,
  // Shared current internal note ID for syncing between left panel and pegboard
  currentInternalNoteId: null,
  // Mock cards array for peg board rendering
  pegboardCards: [
    // {
    //   "id": "c_01H8Z6W8F6E5J3",
    //   "category": "Billing",
    //   "entity_type": "invoice",
    //   "entity_id": "inv_12345",
    //   "metadata": { "invoice_id": "inv_12345" },
    //   "updated_at": "2025-08-26T07:00:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J4",
    //   "category": "basicInfo",
    //   "entity_type": "contact",
    //   "entity_id": "contact_001",
    //   "metadata": { "contact_id": "contact_001" },
    //   "updated_at": "2025-08-25T10:30:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J5",
    //   "category": "basicInfo",
    //   "entity_type": "demographics",
    //   "entity_id": "demo_001",
    //   "metadata": { "demographics_id": "demo_001" },
    //   "updated_at": "2025-08-24T14:15:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J6",
    //   "category": "Calendar",
    //   "entity_type": "appointment",
    //   "entity_id": "apt_001",
    //   "metadata": { "appointment_id": "apt_001" },
    //   "updated_at": "2025-08-23T09:45:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J9",
    //   "category": "Calendar",
    //   "entity_type": "appointment",
    //   "entity_id": "apt_002",
    //   "metadata": { "appointment_id": "apt_002" },
    //   "updated_at": "2025-08-22T08:30:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J10",
    //   "category": "Calendar",
    //   "entity_type": "appointment",
    //   "entity_id": "apt_003",
    //   "metadata": { "appointment_id": "apt_003" },
    //   "updated_at": "2025-08-21T14:15:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J7",
    //   "category": "Calendar",
    //   "entity_type": "task",
    //   "entity_id": "task_001",
    //   "metadata": { "task_id": "task_001" },
    //   "updated_at": "2025-08-22T16:20:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J8",
    //   "category": "Calendar",
    //   "entity_type": "form",
    //   "entity_id": "form_001",
    //   "metadata": { "form_id": "form_001" },
    //   "updated_at": "2025-08-21T11:10:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5K0",
    //   "category": "Medical_Record",
    //   "entity_type": "medication",
    //   "entity_id": "med_001",
    //   "metadata": { "medication_id": "med_001" },
    //   "updated_at": "2025-08-19T08:45:00Z"
    // },
    // {
    //   "id": "c_01H8Z6W8F6E5J91",
    //   "category": "Calendar",
    //   "entity_type": "questionnaire",
    //   "entity_id": "quest_001",
    //   "metadata": { "questionnaire_id": "quest_001" },
    //   "updated_at": "2025-08-20T13:30:00Z"
    // },
  ]
};

// Helper function to get default patient data
const getDefaultPatientData = () => ({
  "Basic_Info": {
    "Contact_Info": {
      "phone": "(555) 123-4567",
      "email": "john.doe@email.com",
      "address": "123 Main St, Anytown, CA 90210",
      "preferredContact": "Phone"
    },
    "Emergency_Contact": {
      "name": "Jane Doe",
      "relationship": "Spouse",
      "phone": "(555) 987-6543",
      "email": "jane.doe@email.com"
    },
  },
});

// Getters
const getters = {
  // Get patient data by patient ID
  getPatientById: (state) => (patientId) => {
    return state.patients[patientId] || null;
  },

  // Get all patients (helper getter)
  getAllPatients: (state) => {
    return state.patients;
  },

  // Get patient contact info by ID
  getPatientContactInfo: (state) => (patientId) => {
    const patient = state.patients[patientId];
    return patient ? patient.Basic_Info?.Contact_Info : null;
  },

  // Get patient emergency contact by ID
  getPatientEmergencyContact: (state) => (patientId) => {
    const patient = state.patients[patientId];
    return patient ? patient.Basic_Info?.Emergency_Contact : null;
  },

  // Get contact card data for display
  getContactCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const contactInfo = patient.Basic_Info?.Contact_Info;
    const emergencyContact = patient.Basic_Info?.Emergency_Contact;

    return {
      phone: contactInfo?.phone || 'Not Provided',
      email: contactInfo?.email || 'Not Provided',
      address: contactInfo?.address || 'Not Provided',
      preferredContact: contactInfo?.preferredContact || 'Not Provided',
      emergencyContact: {
        name: emergencyContact?.name || 'N/A',
        relationship: emergencyContact?.relationship || 'N/A',
        phone: emergencyContact?.phone || 'N/A',
        email: emergencyContact?.email || 'N/A'
      }
    };
  },

  // Get demographics card data for display
  getDemographicsCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const demographics = patient.Basic_Info?.Demographics;

    return {
      gender: demographics?.gender || 'N/A',
      age: demographics?.age || 'N/A',
      dateOfBirth: demographics?.dateOfBirth || 'N/A',
      formattedDateOfBirth: demographics?.formattedDateOfBirth || 'N/A',
      formattedBirthWithAge: `${demographics?.formattedDateOfBirth || 'N/A'}(${demographics?.age || 'N/A'} yrs)`,
      race: demographics?.race || 'N/A',
      ethnicity: demographics?.ethnicity || 'N/A'
    };
  },

  // Get sample card data for display
  getSampleCardData: (state) => (patientId, entityId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const sample = patient.Billing?.Sample;
    return sample.find((sample) => sample.sampleId === entityId)
  },
  // Get billing preference data for display
  getBillingCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const billingPreference = patient.Basic_Info?.Billing_Preference || {};
    return {
      method: billingPreference.method || 'N/A',
      address: billingPreference.address || 'N/A',
    };
  },

  // Get medication card data for display
  getMedicationCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const medications = patient.Medical_Record?.Medication;

    // Return the first medication if available, or default data
    if (medications && medications.length > 0) {
      const primaryMed = medications[0];
      return {
        name: primaryMed.name || 'N/A',
        brandName: primaryMed.brandName || 'N/A',
        displayName: `${primaryMed.brandName || primaryMed.name || 'N/A'}`,
        dosage: primaryMed.dosage || 'N/A',
        frequency: primaryMed.frequency || 'N/A',
        instructions: primaryMed.instructions || 'N/A',
        dosageInstructions: `${primaryMed.dosage || 'N/A'}, ${primaryMed.instructions || 'N/A'}`,
        startDate: primaryMed.startDate || 'N/A',
        formattedStartDate: primaryMed.formattedStartDate || 'N/A',
        startedOn: `Started on ${primaryMed.formattedStartDate || 'N/A'}`,
        prescribedBy: primaryMed.prescribedBy || 'N/A',
        status: primaryMed.status || 'N/A',
        totalMedications: medications.length,
        allMedications: medications
      };
    }

    return {
      name: 'No medications',
      brandName: 'N/A',
      displayName: 'No medications found',
      dosage: 'N/A',
      frequency: 'N/A',
      instructions: 'N/A',
      dosageInstructions: 'N/A',
      startDate: 'N/A',
      formattedStartDate: 'N/A',
      startedOn: 'N/A',
      prescribedBy: 'N/A',
      status: 'N/A',
      totalMedications: 0,
      allMedications: []
    };
  },

  // Get form card data for display
  getFormCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient) return null;

    const forms = patient.Calendar?.Form;

    if (forms && forms.length > 0) {
      return {
        totalForms: forms.length,
        allForms: forms,
        pendingForms: forms.filter(form => form.status === 'Pending'),
        completedForms: forms.filter(form => form.status === 'Completed'),
        highPriorityForms: forms.filter(form => form.priority === 'High'),
        primaryForm: forms[0] || null
      };
    }

    return {
      totalForms: 0,
      allForms: [],
      pendingForms: [],
      completedForms: [],
      highPriorityForms: [],
      primaryForm: null
    };
  },

  // Get questionnaire card data
  getQuestionnaireCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient || !patient.Calendar?.Assigned_Questionnaire) return null;

    const questionnaires = patient.Calendar.Assigned_Questionnaire;

    return {
      totalQuestionnaires: questionnaires.length,
      allQuestionnaires: questionnaires,
      primaryQuestionnaire: questionnaires[0] || null
    };
  },

  getAllergyCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient || !patient.Medical_Record?.Allergies) return null;

    const allergies = patient.Medical_Record.Allergies;

    return allergies[0];
  },

  getNotesCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient || !patient.Medical_Record?.Encounter_Notes) return null;

    const notesInfo = patient.Medical_Record.Encounter_Notes[0];

    return {
      notes: notesInfo.notes,
      date: notesInfo.date,
    }
  },

  getOrderHandlingCardData: (state) => (patientId) => {
    const patient = state.patients[patientId];
    if (!patient || !patient.Basic_Info?.Order_Handling_Preference) return null;

    const orderHandlingInfo = patient.Basic_Info.Order_Handling_Preference;

    return {
      bloodKit: orderHandlingInfo.bloodKit,
      nonBloodKit: orderHandlingInfo.nonBloodKit,
      shippingAddress: orderHandlingInfo.shippingAddress,
    }
  },

  // Get appointment card data
  getAppointmentCardData: (state) => {
    // Use shared state for appointments fetched from calendar API
    const appointments = state.currentPatientAppointments || [];

    // Sort appointments by start time to find the next one
    const sortedAppointments = [...appointments].sort((a, b) =>
      new Date(a.start_time) - new Date(b.start_time)
    );

    // Find next upcoming appointment (not canceled, in the future)
    const now = new Date();
    const nextAppointment = sortedAppointments.find(apt =>
      new Date(apt.start_time) >= now && apt.status !== 'Canceled'
    ) || sortedAppointments[0];

    if (nextAppointment) {
      return {
        totalAppointments: appointments.length,
        allAppointments: appointments,
        nextAppointment: {
          ...nextAppointment,
        }
      };
    }

    return {
      totalAppointments: appointments.length,
      allAppointments: appointments,
      nextAppointment: null
    };
  },

  // Get all appointments for rendering multiple cards
  getAllAppointments: (state) => {
    // Use shared state for appointments fetched from calendar API
    return state.currentPatientAppointments || [];
  },

  // Get appointment by event_id
  getAppointmentByEventId: (state) => (eventId) => {
    const appointments = state.currentPatientAppointments || [];
    // Backend stores entity_id as string, but frontend stores event_id as number
    const numericEventId = Number(eventId);
    return appointments.find(apt =>
      apt.event_id === numericEventId ||
      apt.id === numericEventId
    );
  },

  // Get task by task_id
  getTaskByTaskId: (state) => (taskId) => {
    const tasks = state.currentPatientTasks || [];
    // Backend stores entity_id as string, but frontend stores task_id as number
    const numericTaskId = Number(taskId);
    return tasks.find(task =>
      task.task_id === numericTaskId ||
      task.id === numericTaskId
    );
  },

  // Get task card data
  getTaskCardData: (state) => {
    // Use shared state for tasks fetched from calendar API
    const tasks = state.currentPatientTasks || [];

    // Sort tasks by due date/start date to find the next pending one
    const sortedTasks = [...tasks]
      .filter(task => !task.is_completed)
      .sort((a, b) => {
        const dateA = a.start_date ? new Date(a.start_date) : new Date(0);
        const dateB = b.start_date ? new Date(b.start_date) : new Date(0);
        return dateA - dateB;
      });

    // Find the next pending task
    const primaryTask = sortedTasks[0] || null;

    if (primaryTask) {
      return {
        totalTasks: tasks.length,
        allTasks: tasks,
        primaryTask: {
          ...primaryTask,
          status: primaryTask.is_completed ? 'Completed' : 'Pending'
        }
      };
    }

    return {
      totalTasks: tasks.length,
      allTasks: tasks,
      primaryTask: null
    };
  },

  // Get all tasks for rendering multiple cards
  getAllTasks: (state) => {
    return state.currentPatientTasks || [];
  },

  // Get pegboard cards
  getPegboardCards: (state) => {
    return state.pegboardCards || [];
  },

  // Check if a card is pinned to pegboard
  isCardPinned: (state) => (cardData) => {
    return state.pegboardCards.some(card =>
      card.category === cardData.category &&
      card.entity_type === cardData.entity_type &&
      (cardData.entity_id ? String(card.entity_id) === String(cardData.entity_id) : true)
    );
  },

  // Get pegboard card ID for a tab card
  getPegboardCardId: (state) => (cardData) => {
    const pegboardCard = state.pegboardCards.find(card =>
      card.category === cardData.category &&
      card.entity_type === cardData.entity_type &&
      (cardData.entity_id ? card.entity_id === String(cardData.entity_id) : true)
    );
    return pegboardCard ? pegboardCard.id : null;
  },
  // Get shared medications for current patient
  getCurrentPatientMedications: (state) => {
    return state.currentPatientMedications || [];
  },
  // Get shared allergies for current patient
  getCurrentPatientAllergies: (state) => {
    return state.currentPatientAllergies || [];
  },
  // Get shared health info for current patient
  getCurrentPatientHealthInfo: (state) => {
    return state.currentPatientHealthInfo || null;
  },
  // Get shared billing orders for current patient
  getCurrentPatientBillingOrders: (state) => {
    return state.currentPatientBillingOrders || [];
  },
  // Get billing orders loading state
  getBillingOrdersLoading: (state) => {
    return state.billingOrdersLoading;
  },
  // Get medications loading state
  getMedicationsLoading: (state) => {
    return state.medicationsLoading;
  },
  // Get allergies loading state
  getAllergiesLoading: (state) => {
    return state.allergiesLoading;
  },
  // Get appointments loading state
  getAppointmentsLoading: (state) => {
    return state.appointmentsLoading;
  },
  // Get shared appointments for current patient
  getCurrentPatientAppointments: (state) => {
    return state.currentPatientAppointments;
  },
  // Get tasks loading state
  getTasksLoading: (state) => {
    return state.tasksLoading;
  },
  // Get shared tasks for current patient
  getCurrentPatientTasks: (state) => {
    return state.currentPatientTasks;
  },
  // Get current internal note ID for syncing between components
  getCurrentInternalNoteId: (state) => {
    return state.currentInternalNoteId;
  },
  // Get calendar ID for a patient
  getPatientCalendarId: (state) => (patientId) => {
    return state.patientCalendarIdMap[patientId] || null;
  }
};


// Mutations
const mutations = {
  ORDER_PLACED_SAMPLE(state, { sampleMessage, patientId = "3123765" }) {
    console.log(sampleMessage, patientId, 'sampleMessage, patientId in store', state.patients, 'state.patients')
    // Ensure patient exists
    if (!state.patients[patientId]) {
      state.patients[patientId] = {};
    }
    const patient = state.patients[patientId];
    console.log(patient, 'patient.Billing.Sample in store')
    // Ensure Billing object exists
    if (!patient.Billing) {
      patient.Billing = {};
    }

    // Ensure Sample array exists
    if (!patient.Billing.Sample) {
      patient.Billing.Sample = [];
    }

    // Push the new sample without overwriting existing ones
    patient.Billing.Sample = [...patient.Billing.Sample, sampleMessage];

    console.log(patient.Billing.Sample, 'Updated Sample Array');
  },
  // Update Contact_Info for a patient
  UPDATE_CONTACT_INFO(state, { patientId, contactInfo }) {
    if (state.patients[patientId]) {
      state.patients[patientId].Basic_Info.Contact_Info = contactInfo;
    }
  },

  // Update Emergency_Contact for a patient
  UPDATE_EMERGENCY_CONTACT(state, { patientId, emergencyContact }) {
    if (state.patients[patientId]) {
      state.patients[patientId].Basic_Info.Emergency_Contact = emergencyContact;
    }
  },

  // Initialize Contact_Info for a patient
  INIT_CONTACT_INFO(state, { patientId, contactInfo }) {
    if (state.patients[patientId]) {
      state.patients[patientId].Basic_Info.Contact_Info = contactInfo;
    }
  },

  // Initialize Emergency_Contact for a patient
  INIT_EMERGENCY_CONTACT(state, { patientId, emergencyContact }) {
    if (state.patients[patientId]) {
      state.patients[patientId].Basic_Info.Emergency_Contact = emergencyContact;
    }
  },

  // Update Demographics for a patient
  UPDATE_DEMOGRAPHICS(state, { patientId, demographics }) {
    if (state.patients[patientId]) {
      state.patients[patientId].Basic_Info.Demographics = demographics;
    }
  },

  // Add a new patient with default data structure
  ADD_PATIENT(state, { patientId, patientData = {} }) {
    if (!state.patients[patientId]) {
      // Get default data structure and create a deep copy
      const defaultData = JSON.parse(JSON.stringify(getDefaultPatientData()));

      // Merge with any provided data
      state.patients[patientId] = {
        ...defaultData,
        ...patientData,
        // Ensure nested objects are properly merged
        Basic_Info: {
          ...defaultData.Basic_Info,
          ...(patientData.Basic_Info || {})
        },
        Medical_Record: {
          ...defaultData.Medical_Record,
          ...(patientData.Medical_Record || {})
        },
        Calendar: {
          ...defaultData.Calendar,
          ...(patientData.Calendar || {}),
          Appointments: patientData.Calendar?.Appointments || [],
          Tasks: patientData.Calendar?.Tasks || [],
          Form: patientData.Calendar?.Form || [],
          'Assigned_Questionnaire': patientData.Calendar?.['Assigned_Questionnaire'] || []
        },
        Billing: {
          ...defaultData.Billing,
          ...(patientData.Billing || {})
        }
      }

      console.log(`✅ Added new patient with ID: ${patientId}`, state.patients[patientId]);
    }
  },

  // Update pegboard cards order
  UPDATE_PEGBOARD_CARDS_ORDER(state, newCardOrder) {
    state.pegboardCards = newCardOrder;
  },

  // Add backend users from findPatient API
  ADD_BACKEND_USERS(state, { users, page }) {
    if (Array.isArray(users)) {
      users.forEach(user => {
        if (user.patient_id) {
          const patientId = String(user.patient_id);
          // Format similar to state.patients structure
          state.backendusers[patientId] = {
            patient_id: user.patient_id,
            patient_first_name: user.patient_first_name || '',
            patient_last_name: user.patient_last_name || '',
            patient_middle_name: user.patient_middle_name || '',
            patient_birthdate: user.patient_birthdate || '',
            patient_gender: user.patient_gender || '',
            patient_email: user.patient_email || '',
            patient_telephone: user.patient_telephone || '',
            patient_address: user.patient_address || '',
            patient_street_address: user.patient_street_address || '',
            patient_city: user.patient_city || '',
            patient_state: user.patient_state || '',
            patient_zip_code: user.patient_zip_code || '',
            patient_country: user.patient_country || '',
            Order: user.Order || [],
            Encounter_Notes: user.Encounter_Notes || [],
            ...user // Include any other fields from API
          };
        }
      });
      // Update last loaded page
      if (page && page > state.backendusersLastPage) {
        state.backendusersLastPage = page;
      }
    }
  },

  // Add a card to pegboard
  ADD_PEGBOARD_CARD(state, cardData) {
    // Check if card already exists to avoid duplicates (match by category and entity_type only)
    const existingCard = state.pegboardCards.find(card =>
      card.category === cardData.category &&
      card.entity_type === cardData.entity_type &&
      card.entity_id === cardData.entity_id
    );

    if (!existingCard) {
      // Add new cards to the beginning of the pegboard
      state.pegboardCards.unshift(cardData);
    }
  },

  // Update a specific card in the pegboard
  UPDATE_PEGBOARD_CARD(state, { cardId, updatedCard }) {
    const cardIndex = state.pegboardCards.findIndex(card => card.id === cardId);
    if (cardIndex !== -1) {
      state.pegboardCards[cardIndex] = { ...state.pegboardCards[cardIndex], ...updatedCard };
    }
  },

  // Remove a card from pegboard
  REMOVE_PEGBOARD_CARD(state, cardId) {
    const index = state.pegboardCards.findIndex(card => card.id === cardId);
    if (index !== -1) {
      // Create new array to ensure Vue reactivity
      const newCards = [...state.pegboardCards];
      newCards.splice(index, 1);
      state.pegboardCards = newCards;
    }
  },
  SET_PEGBOARD_VERSION(state, version) {
    state.pegboardCardVersion = version;
  },

  // Set shared medications for current patient
  SET_CURRENT_PATIENT_MEDICATIONS(state, medications) {
    state.currentPatientMedications = medications;
  },
  // Set shared allergies for current patient
  SET_CURRENT_PATIENT_ALLERGIES(state, allergies) {
    state.currentPatientAllergies = allergies;
  },
  // Set shared health info for current patient
  SET_CURRENT_PATIENT_HEALTH_INFO(state, healthInfo) {
    state.currentPatientHealthInfo = healthInfo;
  },
  // Set health info loading state
  SET_HEALTH_INFO_LOADING(state, isLoading) {
    state.healthInfoLoading = isLoading;
  },
  // Set shared billing orders for current patient
  SET_CURRENT_PATIENT_BILLING_ORDERS(state, billingOrders) {
    state.currentPatientBillingOrders = billingOrders;
  },
  // Set billing orders loading state
  SET_BILLING_ORDERS_LOADING(state, isLoading) {
    state.billingOrdersLoading = isLoading;
  },
  // Set shared documents for current patient
  SET_CURRENT_PATIENT_DOCUMENTS(state, documents) {
    state.currentPatientDocuments = documents;
  },
  // Set documents loading state
  SET_DOCUMENTS_LOADING(state, isLoading) {
    state.documentsLoading = isLoading;
  },
  // Set pegboard loading state
  SET_PEGBOARD_LOADING(state, isLoading) {
    state.pegboardLoading = isLoading;
  },
  // Set medications loading state
  SET_MEDICATIONS_LOADING(state, isLoading) {
    state.medicationsLoading = isLoading;
  },
  // Set allergies loading state
  SET_ALLERGIES_LOADING(state, isLoading) {
    state.allergiesLoading = isLoading;
  },
  // Set appointments loading state
  SET_APPOINTMENTS_LOADING(state, isLoading) {
    state.appointmentsLoading = isLoading;
  },
  // Set shared appointments for current patient
  SET_CURRENT_PATIENT_APPOINTMENTS(state, appointments) {
    state.currentPatientAppointments = appointments;
  },
  // Set tasks loading state
  SET_TASKS_LOADING(state, isLoading) {
    state.tasksLoading = isLoading;
  },
  // Set shared tasks for current patient
  SET_CURRENT_PATIENT_TASKS(state, tasks) {
    state.currentPatientTasks = tasks;
  },
  // Update a single medication in the list
  UPDATE_MEDICATION(state, updatedMedication) {
    const index = state.currentPatientMedications.findIndex(m => m.id === updatedMedication.id);
    if (index !== -1) {
      state.currentPatientMedications.splice(index, 1, updatedMedication);
    }
  },
  // Add a new medication to the list
  ADD_MEDICATION(state, medication) {
    state.currentPatientMedications.push(medication);
  },
  // Remove a medication from the list
  REMOVE_MEDICATION(state, medicationId) {
    const index = state.currentPatientMedications.findIndex(m => m.id === medicationId);
    if (index !== -1) {
      state.currentPatientMedications.splice(index, 1);
    }
  },
  // Update a single allergy in the list
  UPDATE_ALLERGY(state, updatedAllergy) {
    const index = state.currentPatientAllergies.findIndex(a => a.id === updatedAllergy.id);
    if (index !== -1) {
      state.currentPatientAllergies.splice(index, 1, updatedAllergy);
    }
  },
  // Add a new allergy to the list
  ADD_ALLERGY(state, allergy) {
    state.currentPatientAllergies.push(allergy);
  },
  // Remove an allergy from the list
  REMOVE_ALLERGY(state, allergyId) {
    const index = state.currentPatientAllergies.findIndex(a => a.id === allergyId);
    if (index !== -1) {
      state.currentPatientAllergies.splice(index, 1);
    }
  },
  // Set current internal note ID for syncing between components
  SET_CURRENT_INTERNAL_NOTE_ID(state, noteId) {
    state.currentInternalNoteId = noteId;
  },

  // Update patient's calendar tasks
  UPDATE_PATIENT_CALENDAR_TASKS(state, { patientId, tasks }) {
    if (state.patients[patientId] && state.patients[patientId].Calendar) {
      state.patients[patientId].Calendar.Tasks = tasks;
    }
  },

  // Update patient's calendar appointments
  UPDATE_PATIENT_CALENDAR_APPOINTMENTS(state, { patientId, appointments }) {
    if (state.patients[patientId] && state.patients[patientId].Calendar) {
      state.patients[patientId].Calendar.Appointments = appointments;
    }
  },

  // Update patient's calendar tasks
  UPDATE_PATIENT_CALENDAR_TASKS(state, { patientId, tasks }) {
    if (state.patients[patientId] && state.patients[patientId].Calendar) {
      state.patients[patientId].Calendar.Tasks = tasks;
    }
  },

  // Store patient calendar ID mapping from clinic data
  SET_PATIENT_CALENDAR_ID_MAP(state, patientCalendarIdMap) {
    state.patientCalendarIdMap = {
      ...state.patientCalendarIdMap,
      ...patientCalendarIdMap
    };
  },
};

// Actions (for future async operations)
import {
  getPegBoardListApi,
  pinCardApi,
  unpinCardApi,
  updateCardOrderApi
} from '@/api/rocketChat';

import {
  getMedicationRecords,
  getAllergyRecords
} from '@/api/medicationApi';

import { getPatientByIdApi } from '@/api/patient';
import { getRecentVitals, transformVitalsToHealthInfo } from '@/api/vitalsApi';
import { getPatientAppointmentsApi, getPatientTasksApi } from '@/api/calendarApi';
import { getPatientBillingTabsApi } from '@/api/billingApi';
import { getPatientFilesApi } from '@/api/patientFiles';

// Helper function to transform API response to patient data structure
const transformApiResponseToPatientData = (apiData) => {
  // Calculate age from birthdate
  const calculateAge = (birthdate) => {
    if (!birthdate) return 0;
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Format date to "MMM-DD-YYYY"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    // Parse date components directly to avoid timezone issues
    const [year, month, day] = dateString.split('-').map(Number);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[month - 1]}-${String(day).padStart(2, '0')}-${year}`;
  };

  // Extract contact information from patient_contact array
  const phoneContact = apiData.patient_contact?.find(c => c.contact_type === 'phone');
  const emailContact = apiData.patient_contact?.find(c => c.contact_type === 'email');

  // Extract address from patient_address array (use shipping address if available)
  const shippingAddress = apiData.patient_address?.find(a => a.address_type === 'shipping') || apiData.patient_address?.[0];
  const fullAddress = shippingAddress
    ? `${shippingAddress.street_address}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.zipcode}`
    : '';

  const age = calculateAge(apiData.patient_birthdate);
  const formattedBirthdate = formatDate(apiData.patient_birthdate);

  return {
    Basic_Info: {
      Contact_Info: {
        phone: phoneContact?.contact_details || '',
        email: emailContact?.contact_details || '',
        address: fullAddress,
        preferredContact: phoneContact?.is_primary_contact ? 'Phone' : (emailContact?.is_primary_contact ? 'Email' : 'Phone')
      },
      Emergency_Contact: {
        name: '',
        relationship: '',
        phone: '',
        email: ''
      },
      Date_of_Birth: apiData.patient_birthdate || '',
      Demographics: {
        gender: apiData.patient_gender || '',
        age: age,
        dateOfBirth: apiData.patient_birthdate || '',
        formattedDateOfBirth: formattedBirthdate,
        formattedBirthWithAge: `${formattedBirthdate}(${age} yrs)`,
        race: '',
        ethnicity: apiData.patient_ethnicity || ''
      },
      Billing_Preference: {
        method: '',
        address: ''
      },
      Order_Handling_Preference: {
        bloodKit: '',
        nonBloodKit: '',
        shippingAddress: ''
      }
    },
    Medical_Record: {
      Medication: [],
      Allergies: [],
      Encounter_Notes: [],
      All_Documents: {
        totalDocs: 0,
        medicalReports: 0,
        encounterNotes: 0,
        uploadedDocs: 0
      }
    },
    Calendar: {
      Appointments: [],
      Tasks: [],
      Form: [],
      Assigned_Questionnaire: []
    },
    Billing: {
      Billing: [],
      Sample: (apiData.orderitem || []).map((item, index) => ({
        id: `sample_${item.sample_id}`,
        serviceDate: formatDate(item.service_date),
        status: 'Order Created',
        statusDescription: 'The order has been successfully created in the system.',
        sampleId: String(item.sample_id),
        orderTestNames: item.accession_id || 'Sample',
        samplePlacedDate: item.service_date || '',
        questionnaireStatus: '–',
        questionnaireDescription: '–'
      })),
      Orders: [],
      VitalSigns: {
        height: '',
        weight: ''
      }
    }
  }
};

// Helper function to transform calendar event data to appointment card format
const transformCalendarEventToAppointment = (event) => {
  if (!event) return null;

  const startDate = new Date(event.start_time);
  const endDate = new Date(event.end_time);

  // Calculate duration in minutes
  const duration = Math.round((endDate - startDate) / 60000);

  // Format date for display (MMM-DD-YYYY)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const formattedDate = `${months[startDate.getMonth()]}-${String(startDate.getDate()).padStart(2, '0')}-${startDate.getFullYear()}`;

  // Format time (e.g., "10:00 AM")
  const formatTime = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
  };

  const formattedTime = `${formatTime(startDate)} - ${formatTime(endDate)}`;

  return {
    id: event.event_id,
    date: event.start_time,
    formattedDate: formattedDate,
    time: formatTime(startDate),
    formattedTime: formattedTime,
    duration: duration,
    title: event.event_title,
    type: event.event_type || 'Appointment',
    location: event.location || 'TBD',
    notes: event.notes || '',
    status: event.is_canceled ? 'Canceled' : 'Scheduled',
    attendees: event.participants?.map(p => p.participant_calendar_id) || [],
    // Extra fields for card display
    month: months[startDate.getMonth()],
    day: startDate.getDate(),
    weekday: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][startDate.getDay()],
    // Keep original event data for reference
    event_id: event.event_id,
    uuid: event.uuid,
    start_time: event.start_time,
    end_time: event.end_time
  };
};

const actions = {
  // Update contact information
  updateContactInfo({ commit }, payload) {
    commit('UPDATE_CONTACT_INFO', payload);
  },

  // Update emergency contact
  updateEmergencyContact({ commit }, payload) {
    commit('UPDATE_EMERGENCY_CONTACT', payload);
  },

  // Initialize contact info
  initContactInfo({ commit }, payload) {
    commit('INIT_CONTACT_INFO', payload);
  },

  // Initialize emergency contact
  initEmergencyContact({ commit }, payload) {
    commit('INIT_EMERGENCY_CONTACT', payload);
  },

  // Update demographics information
  updateDemographics({ commit }, payload) {
    commit('UPDATE_DEMOGRAPHICS', payload);
  },

  async getPegboardList({ commit }, { customer_id, clinic_id, patient_id }) {
    commit('SET_PEGBOARD_LOADING', true);
    try {
      const response = await getPegBoardListApi(customer_id, clinic_id, patient_id);
      commit('UPDATE_PEGBOARD_CARDS_ORDER', response.data.cards);
      commit('SET_PEGBOARD_VERSION', response.data.version);

      // Backfill Billing.Sample in patient info if missing, using pegboard card metadata
      const cards = Array.isArray(response.data.cards) ? response.data.cards : [];
      cards
        .filter(card => card.category === 'Billing' && card.entity_type === 'sample')
        .forEach(card => {
          try {
            const p = state.patients[patient_id];
            const sampleList = p && p.Billing && Array.isArray(p.Billing.Sample) ? p.Billing.Sample : [];
            const exists = sampleList.some(s => String(s.sampleId) === String(card.entity_id));
            if (!exists) {
              const meta = card.metadata || {};
              const now = new Date();
              const pad2 = (n) => String(n).padStart(2, '0');
              const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              const serviceDate = meta.serviceDate || `${monthNames[now.getMonth()]}-${pad2(now.getDate())}-${now.getFullYear()}`;

              const sampleMessage = {
                id: `sample_${card.entity_id}`,
                serviceDate,
                status: meta.status || 'Order Created',
                statusDescription: 'The order has been successfully created in the system.',
                sampleId: String(card.entity_id),
                orderTestNames: meta.sampleName || 'Sample',
                samplePlacedDate: `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`,
                questionnaireStatus: '–',
                questionnaireDescription: '–'
              };
              commit('ORDER_PLACED_SAMPLE', { sampleMessage, patientId: patient_id });
            }
          } catch (e) {
            console.warn('Failed to backfill sample from pegboard card', card, e);
          }
        });
    } catch (error) {
      console.error('Error fetching pegboard data:', error);
      throw error;
    } finally {
      commit('SET_PEGBOARD_LOADING', false);
    }
  },

  async pinCard({ commit }, { customer_id, clinic_id, patient_id, cardData }) {
    try {
      const response = await pinCardApi(customer_id, clinic_id, patient_id, cardData);
      if (response.data && response.data.id) {
        const newCard = {
          ...cardData,
          id: response.data.id,
          metadata: cardData.metadata || {},
          updated_at: new Date().toISOString(),
        };
        commit('ADD_PEGBOARD_CARD', newCard);
      }
    } catch (error) {
      console.error('Error pinning card:', error);
      throw error;
    }
  },

  async unpinCard({ commit }, { customer_id, clinic_id, patient_id, card_id }) {
    try {
      await unpinCardApi(customer_id, clinic_id, patient_id, card_id);
      commit('REMOVE_PEGBOARD_CARD', card_id);
    } catch (error) {
      console.error('Error unpinning card:', error);
      throw error;
    }
  },

  async updatePegboardCardsOrder({ commit, state }, { customer_id, clinic_id, patient_id, newCardOrder, newCardOrderIds }) {
    try {
      console.log("updatePegboardCardsOrder", customer_id, clinic_id, patient_id, newCardOrder, newCardOrderIds)
      const response = await updateCardOrderApi(customer_id, clinic_id, patient_id, newCardOrderIds, state.pegboardCardVersion);
      if (response.status === 200) {
        commit('UPDATE_PEGBOARD_CARDS_ORDER', newCardOrder);
        commit('SET_PEGBOARD_VERSION', response.data.version);
      }
    } catch (error) {
      console.error('Error updating pegboard cards order:', error);
      throw error;
    }
  },
  // Fetch medications for current patient and store in shared state
  async fetchCurrentPatientMedications({ commit }, patientId) {
    if (!patientId) return;
    commit('SET_MEDICATIONS_LOADING', true);
    try {
      const response = await getMedicationRecords(patientId);
      const medications = (response.data || []).map(med => ({
        id: med.id,
        name: med.medication_name,
        dose: med.dose_value && med.dose_unit ? `${med.dose_value} ${med.dose_unit}` : med.dosage || '',
        frequencyNumber: med.frequency_value || '',
        frequencyPeriod: med.frequency_period || '',
        startDate: med.start_date ? med.start_date.split('T')[0] : '',
        endDate: med.end_date ? med.end_date.split('T')[0] : '',
        isActive: med.is_active
      }));
      commit('SET_CURRENT_PATIENT_MEDICATIONS', medications);
      return medications;
    } catch (error) {
      console.error('Failed to fetch medications:', error);
      commit('SET_CURRENT_PATIENT_MEDICATIONS', []);
      throw error;
    } finally {
      commit('SET_MEDICATIONS_LOADING', false);
    }
  },
  // Fetch allergies for current patient and store in shared state
  async fetchCurrentPatientAllergies({ commit }, patientId) {
    if (!patientId) return;
    commit('SET_ALLERGIES_LOADING', true);
    try {
      const response = await getAllergyRecords(patientId);
      const allergies = (response.data || []).map(allergy => ({
        id: allergy.id,
        allergen: allergy.allergen_name,
        reactions: allergy.reactions,
        severity: allergy.overall_severity?.toLowerCase() || ''
      }));
      commit('SET_CURRENT_PATIENT_ALLERGIES', allergies);
      return allergies;
    } catch (error) {
      console.error('Failed to fetch allergies:', error);
      commit('SET_CURRENT_PATIENT_ALLERGIES', []);
      throw error;
    } finally {
      commit('SET_ALLERGIES_LOADING', false);
    }
  },
  // Fetch vitals for current patient and store in shared state
  async fetchCurrentPatientVitals({ commit }, patientId) {
    if (!patientId) return;
    commit('SET_HEALTH_INFO_LOADING', true);
    commit('SET_CURRENT_PATIENT_HEALTH_INFO', null);
    try {
      const response = await getRecentVitals(patientId);
      const healthInfo = transformVitalsToHealthInfo(response.entries);
      commit('SET_CURRENT_PATIENT_HEALTH_INFO', healthInfo);
      return healthInfo;
    } catch (error) {
      console.error('Failed to fetch vitals:', error);
      commit('SET_CURRENT_PATIENT_HEALTH_INFO', null);
    } finally {
      commit('SET_HEALTH_INFO_LOADING', false);
    }
  },
  // Fetch billing orders for current patient and store in shared state
  async fetchCurrentPatientBillingOrders({ commit, rootState }, patientId) {
    if (!patientId) return;
    commit('SET_BILLING_ORDERS_LOADING', true);
    try {
      const clinicId = rootState.login?.userInfo?.clinic_id;
      const params = {
        patient_id: patientId,
        limit: 20
      };

      if (clinicId) {
        params.clinic_id = clinicId;
      }

      const response = await getPatientBillingTabsApi(params);
      const billingOrders = response?.data || [];
      commit('SET_CURRENT_PATIENT_BILLING_ORDERS', billingOrders);
      return billingOrders;
    } catch (error) {
      console.error('Failed to fetch billing orders:', error);
      commit('SET_CURRENT_PATIENT_BILLING_ORDERS', []);
      throw error;
    } finally {
      commit('SET_BILLING_ORDERS_LOADING', false);
    }
  },
  // Fetch documents/files for current patient and store in shared state
  async fetchCurrentPatientDocuments({ commit, rootState }, patientId) {
    if (!patientId) return;
    commit('SET_DOCUMENTS_LOADING', true);
    try {
      const clinicId = rootState.login?.userInfo?.clinic_id;
      if (!clinicId) {
        commit('SET_CURRENT_PATIENT_DOCUMENTS', []);
        return [];
      }
      const response = await getPatientFilesApi(clinicId, patientId);
      const documents = response?.data || [];
      commit('SET_CURRENT_PATIENT_DOCUMENTS', documents);
      return documents;
    } catch (error) {
      console.error('Failed to fetch patient documents:', error);
      commit('SET_CURRENT_PATIENT_DOCUMENTS', []);
      throw error;
    } finally {
      commit('SET_DOCUMENTS_LOADING', false);
    }
  },
  // Update medication in shared state
  updateMedication({ commit }, medication) {
    commit('UPDATE_MEDICATION', medication);
  },
  // Add medication to shared state
  addMedication({ commit }, medication) {
    commit('ADD_MEDICATION', medication);
  },
  // Remove medication from shared state
  removeMedication({ commit }, medicationId) {
    commit('REMOVE_MEDICATION', medicationId);
  },
  // Update allergy in shared state
  updateAllergy({ commit }, allergy) {
    commit('UPDATE_ALLERGY', allergy);
  },
  // Add allergy to shared state
  addAllergy({ commit }, allergy) {
    commit('ADD_ALLERGY', allergy);
  },
  // Remove allergy from shared state
  removeAllergy({ commit }, allergyId) {
    commit('REMOVE_ALLERGY', allergyId);
  },
  // Set current internal note ID for syncing between components
  setCurrentInternalNoteId({ commit }, noteId) {
    commit('SET_CURRENT_INTERNAL_NOTE_ID', noteId);
  },

  // Fetch patient appointments from calendar API
  async fetchPatientAppointments({ commit, rootState }, patientId) {
    if (!patientId) return [];

    commit('SET_APPOINTMENTS_LOADING', true);

    try {
      // Ensure calendar ID is initialized before fetching appointments
      let calendarId = rootState.calendar.creatorCalendarId;
      if (!calendarId) {
        const userInfo = rootState.login.userInfo;
        if (userInfo) {
          const getOrCreateCalendarInput = {
            calendar_owner_id: userInfo.customer_id,
            role: userInfo.user_roles?.includes('clinic') ? 'clinicadmin' : 'provider',
            practice_id: userInfo.clinic_id
          };
          await this.dispatch('calendar/getOrCreateCalendar', getOrCreateCalendarInput);
          calendarId = rootState.calendar.creatorCalendarId;
        }
      }

      if (!calendarId) {
        commit('SET_CURRENT_PATIENT_APPOINTMENTS', []);
        return [];
      }

      const events = await getPatientAppointmentsApi(patientId);

      // Store original API data with 'id' field for pegboard compatibility
      const appointments = events
        .filter(event => !event.is_canceled)
        .map(event => ({
          ...event,
          id: event.event_id // Add 'id' field for pegboard and v-for compatibility
        }));

      // Store in shared state (like medications and allergies)
      commit('SET_CURRENT_PATIENT_APPOINTMENTS', appointments);

      // Also update patient's calendar appointments in store (for pegboard compatibility)
      commit('UPDATE_PATIENT_CALENDAR_APPOINTMENTS', {
        patientId,
        appointments
      });

      return appointments;
    } catch (error) {
      console.error('Failed to fetch patient appointments');
      // Set empty array on error
      commit('SET_CURRENT_PATIENT_APPOINTMENTS', []);
      return [];
    } finally {
      commit('SET_APPOINTMENTS_LOADING', false);
    }
  },

  // Fetch patient tasks from calendar API
  async fetchPatientTasks({ commit }, patientId) {
    if (!patientId) return [];

    commit('SET_TASKS_LOADING', true);

    try {
      const rawTasks = await getPatientTasksApi(patientId);

      // Add 'id' field for pegboard and v-for compatibility
      const tasks = rawTasks.map(task => ({
        ...task,
        id: task.task_id
      }));

      // Store in shared state (like medications and allergies)
      commit('SET_CURRENT_PATIENT_TASKS', tasks);

      // Also update patient's calendar tasks in store (for pegboard compatibility)
      commit('UPDATE_PATIENT_CALENDAR_TASKS', {
        patientId,
        tasks
      });

      return tasks;
    } catch (error) {
      console.error('Failed to fetch patient tasks');
      // Set empty array on error
      commit('SET_CURRENT_PATIENT_TASKS', []);
      return [];
    } finally {
      commit('SET_TASKS_LOADING', false);
    }
  },

  // Fetch patient data from API and their appointments
  async fetchPatientCalendarIdMap({ rootState, commit }) {
    const userInfo = rootState.login.userInfo;
    if (!userInfo?.clinic_id) {
      console.warn('No clinic ID found, cannot fetch clinic data');
      return;
    }

    try {
      console.log('Fetching clinic data for patient mapping...');
      const { data } = await transSericeApolloClient.query({
        query: GET_CLINIC,
        variables: { clinicId: userInfo.clinic_id },
        fetchPolicy: 'network-only'
      });

      // Store patient ID → calendar ID mapping
      const patients = data?.getClinic?.clinic_patients || [];
      const patientCalendarIdMap = {};
      patients.forEach(patient => {
        if (patient.id && patient.calendar_id) {
          patientCalendarIdMap[String(patient.id)] = patient.calendar_id;
        }
      });

      commit('SET_PATIENT_CALENDAR_ID_MAP', patientCalendarIdMap);
    } catch (error) {
      console.error('Failed to fetch clinic data');
    }
  },

  async fetchPatientById({ commit }, patientId) {
    try {
      const response = await getPatientByIdApi(patientId);
      const patientData = response.data;

      if (patientData) {
        // Initialize patient with basic data using mutation
        commit('ADD_PATIENT', {
          patientId,
          patientData: {
            patient_id: patientData.patient_id,
            // Add other basic fields as needed
          }
        });

        // Note: Appointments are fetched by the activeTab watcher when calendar tab is activated
      }

      return patientData;
    } catch (error) {
      console.error('Failed to fetch patient by ID:', error);
      throw error;
    }
  }
};

// Export the module
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};